export enum ShiftListSelectionMode {
  Multiple = 'MULTIPLE',
  Single = 'SINGLE',
}
